module.exports = "/static/assets/1c6bb07121b82bb055f9e7c3f85a16fd.png";